/* eslint-disable no-template-curly-in-string */
import React, { useState } from "react";
import {
  Avatar,
  Badge,
  Box,
  Button,
  Card,
  CardContent,
  CircularProgress,
  Divider,
  Grid,
  IconButton,
  Tooltip,
  Typography,
} from "@mui/material";
import {
  Timeline,
  TimelineItem,
  TimelineOppositeContent,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
} from "@mui/lab";
import { color } from "@mui/system";
import {
  AppointmentDto,
  ContinuousAppointmentDto,
  PatientAvailabilityDto,
  TimeSlotDto,
} from "../../api-client/api";
import { format } from "date-fns";
import useStore from "../../helpers/useStore";
import { AppointmentContext } from "../../stores/Appointment/appointment.provider";
import WarningDialog from "../../atoms/WarningDialog";
import {
  AccessTime,
  Cancel,
  CheckCircle,
  Error,
  InsertInvitation,
  NoteAlt,
  NoteAltOutlined,
  AutoAwesome,
  EditCalendar,
  Business,
  Home,
  Store,
  Delete,
} from "@mui/icons-material";
import AppointmentSuggestion from "./Appointments/AppointmentSuggestion";
import AppointmentNotes from "../../molecules/Calendar/AppointmentNotes";
import ScheduleSendIcon from "@mui/icons-material/ScheduleSend";
import { formatDateUI } from "../../helpers/dateFormat";
import { useNavigate } from "react-router-dom";
import { CalendarCommands } from "../../stores/Calendar/calendar.commands";
import { CalendarContext } from "../../stores/Calendar/calendar.provider";
import TerminView from "../PatientOverview/RxInfo/TerminView";
import { TerminViewConstants } from "../PatientOverview/TerminView";
import { TherapySlotRow } from "../../molecules/TherapySlotRow";
import { AppointmentTime } from "../../molecules/AppointmentTime";
import { cardShell } from "../../molecules/cardShell";
import { mobiliTheme } from "../../themes/mobiliTheme";
import { observer } from "mobx-react";
import {
  useDeleteAppointment,
  useDeleteContinous,
  useDeleteUnscheduledAppointments,
  useSetAttended,
} from "../../stores/Appointment/appointment.mutation";

import { useAppointmentNotes } from "../../stores/Notes/notes.queries";
import { UserContext } from "../../stores/User/User.provider";
import { useReschedulingAgent } from "../../hooks/useReschedulingAgent";
import { AutoFixHigh } from "@mui/icons-material";
import { slotsInChronologicalOrder } from "../../helpers/slotTherapy";

// Define an interface for the appointment object
interface Appointment {
  id: string;
  start: string | undefined;
  // Add other properties of the appointment object here
}

interface UnscheduledAppointmentsProps {
  appointments: any[];
  continuousAppointments?: ContinuousAppointmentDto[];
  patientId: any;
  blockedData: TimeSlotDto[];
  setblockedData: any;
  patientAvailabilityData: PatientAvailabilityDto[];
  setPatientAvailability: any;
  appointmentsLoading: boolean;
  cancelledAppointmentsList: AppointmentDto[];
}
const date = (date: any) => {
  const dateString: string | undefined = format(date, "dd.MM.yyyy");
  const dateobj = dateString ? new Date(dateString) : null;
  return dateobj;
};

export const AppointmentCard = ({ appointment }: { appointment: any }) => {
  const { timeSlots } = appointment;

  return (
    <Tooltip title={appointment?.address?.contactInfo?.addressLine1 || "-"}>
      <Box
        className={cardShell()}
        sx={{
          position: "relative",
          p: 0,
          m: 0,
          padding: "2px 4px",
          margin: "0px",
          minWidth: "200px",
        }}
      >
        {/* First grid in one row */}
        <Grid container>
          <Grid item xs={6} display="flex" justifyContent="space-between">
            {/* Date on the left side */}
            <Typography
              sx={{
                fontSize: "0.75em",
                fontWeight: "bold",
                padding: "0px",
                textDecoration:
                  appointment.end === null && appointment.originalDate ? "line-through" : "none",
                textDecorationThickness: "2px",
              }}
            >
              {appointment.start && !appointment.unschedule ? formatDateUI(appointment.start) : ""}
            </Typography>
          </Grid>
          <Grid
            item
            xs={6}
            sx={{
              display: "flex",
              justifyContent: "flex-end",
              alignItems: "flex-start",
            }}
          >
            {/* Start time on the right side; the end lives in the tooltip. */}
            {!appointment.unschedule && (
              <AppointmentTime
                className="text-mini font-bold tabular-nums underline whitespace-nowrap"
                start={appointment.start}
                end={appointment.end}
                label="Termin"
              />
            )}
          </Grid>
        </Grid>

        {/* Second grid in another row */}
        <Grid container>
          {slotsInChronologicalOrder(timeSlots)
            .map((timeSlot: any, index: any) => (
              <Grid item xs={12} key={index}>
                <TherapySlotRow
                  timeSlot={timeSlot}
                  appointment={appointment}
                  index={index}
                  totalSlots={timeSlots.length}
                />
              </Grid>
            ))}
        </Grid>
      </Box>
    </Tooltip>
  );
};
// export const AppointmentCard = ({
//   appointment,
//   onAddNotes,
// }: {
//   appointment: any;
//   onAddNotes?: () => void;
// }) => {
//   const { timeSlots } = appointment;
//   // Calculate the height based on the number of therapyRx items
//   const cardHeight = `${timeSlots.length * 30 + 20}px`; // Adjust the height calculation as needed

//   // Determine the background color based on conditions
//   const backgroundColor = appointment.start
//   ? appointment.attended
//     ? mobiliTheme.palette.success.main // If attended and appointment.start exists
//     : mobiliTheme.palette.primary.main // If unattended and appointment.start exists
//   : (appointment.originalDate && !appointment.resolved && !appointment.end)
//   ? "transparent" // If resolved is false, and originalDate exists but end is null, apply the striped event
//   : mobiliTheme.palette.info.main; // Default color when appointment.start is not present

//   return (
//     <div>
//       {/* Icon Button for adding notes as a tag */}
//       <Tooltip title="Notizen">
//         <IconButton
//           sx={{
//             position: "absolute !important",
//             top: -12, // Position at the top of the card
//             left: -25, // Position at the left of the card
//             // backgroundColor: 'white', // Adjust the icon button background color
//             borderRadius: "0 !important", // Remove border radius to make it a square tag
//             zIndex: 1, // Place it above the card content
//             visibility: onAddNotes ? "visible" : "hidden", // Show the icon button only if onAddNotes is defined
//           }}
//           onClick={onAddNotes}
//         >
//           <Badge color="secondary">
//             <NoteAlt />
//           </Badge>
//         </IconButton>
//       </Tooltip>

//       <Box sx={{ padding: "0px", border: "0px dotted red",width:"300px" }}>
//         <Box
//         className={appointment.originalDate && !appointment.resolved && !appointment.end ? 'striped-cancelled-event' : ''} // Apply class if striped
//           sx={{
//             position: "relative",
//             border:`1px solid ${mobiliTheme.mainHeader}`,
//             p: 0,
//             m: 0,
//             padding: "0px",
//             paddingBottom: "4px",
//             margin: "0px",
//             height: cardHeight,
//               // display: "flex",
//             justifyContent: "center", // Center horizontally
//             alignItems: "center", // Center vertically
//             backgroundColor: backgroundColor,
//             borderRadius: "0.4em",
//           }}
//         >
//          {/* Second grid in another row */}
//         <Grid container >
//           {timeSlots
//           .map((timeSlot: any, index: any) => (
//             <Grid item xs={12} key={index}>
//               <TherapyCard timeSlot={timeSlot} />
//             </Grid>
//           ))}
//         </Grid>
//         </Box>
//         </Box>
//     </div>
//   );
// };

// const AppointmentCard = ({ appointment }: { appointment: any }) => {
//   const { timeSlots } = appointment;
//   // Calculate the height based on the number of therapyRx items
//   const cardHeight = `${timeSlots.length * 30 + 20}px`; // Adjust the height calculation as needed
//   return (
//     <>
//       <Card
//         sx={{
//           height: cardHeight,
//           background: appointment.start ? "blue" : "grey",
//         }}
//       >
//         <CardContent>
//           <Grid container spacing={1}>
//             {timeSlots.map((timeSlot: any, index: any) => (
//               <Grid item xs={12} key={index}>
//                 <TherapyCard timeSlot={timeSlot} />
//               </Grid>
//             ))}
//           </Grid>
//         </CardContent>

//       </Card>
//     </>
//   );
// };
export interface DeleteEvent {
  selectedAppointment: string;
  isContinuous: boolean;
  isDeleteDialogOpen: boolean;
  inCludesCancelled?: boolean;
}

const UnscheduledAppointments = observer(
  ({
    appointments,
    continuousAppointments,
    patientId,
    blockedData,
    setblockedData,
    patientAvailabilityData,
    setPatientAvailability,
    appointmentsLoading,
    cancelledAppointmentsList,
  }: UnscheduledAppointmentsProps) => {
    // mutateAsync resolves only after onSuccess finished, i.e. after the
    // awaited cache invalidations have refetched — so "await" spans the whole
    // visible update, not just the HTTP call.
    const { mutateAsync: deleteAppointment, isPending: isDeletingAppointment } =
      useDeleteAppointment();
    const { mutateAsync: deleteContinuousAppointment, isPending: isDeletingContinuous } =
      useDeleteContinous();
    const { mutateAsync: deleteUnscheduledAppointments } = useDeleteUnscheduledAppointments();
    const { mutate: setAttended } = useSetAttended();
    const isDeleting = isDeletingAppointment || isDeletingContinuous;

    const [showNotesDialog, setShowNotesDialog] = useState(false);
    const [isWarningDialogOpen, setWarningDialogOpen] = useState(false);
    const [selectedAppointment, setSelectedAppointment] = useState<Appointment | null>(null); // Track the selected appointment for the dialog
    const [isSuggestionDialogOpen, setsuggestionDialogOpen] = useState(false);
    const appointmentStore = useStore(AppointmentContext);
    const [selectedAppointmentId, setSelectedAppointmentId] = useState<string | null>(null);
    const { data: appointmentNotesData = [] } = useAppointmentNotes(
      selectedAppointmentId || undefined,
      !!selectedAppointmentId,
    );

    // const [fetchNotes, setFetchNotes] = useState(true); // Use a flag
    const [deleteEvent, setDeleteEvent] = useState<DeleteEvent | null>(null);
    const [inCludesCancellation, setInCludesCancellation] = useState(false);
    const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
    const handleOpenDialog = () => {
      const hasCancelledEvent = cancelledAppointmentsList?.some((appointment: any) =>
        appointments.some((unscheduled: any) => appointment?.id === unscheduled.id),
      );
      setInCludesCancellation(hasCancelledEvent ? true : false);
      setOpenDeleteDialog(true);
    };
    const handleCloseDialog = () => setOpenDeleteDialog(false);
    const [dataSaving, setDataSaving] = useState(false);

    const navigate = useNavigate();
    const calendarStore = useStore(CalendarContext);
    const { navigateToCalendar } = CalendarCommands(calendarStore);
    const UserStore = useStore(UserContext);
    const canSeeFeaturePreview = UserStore.hasPermission("featurePreview");
    const { startRescheduling } = useReschedulingAgent(patientId);

    const handleDeleteEvent = (data: any) => {
      const selectedId = data.selectedAppointment; // Get selected appointment ID safely

      const hasCancelledEvent = cancelledAppointmentsList?.some(
        (appointment: any) => appointment?.id === selectedId,
      );
      setDeleteEvent({ ...data, inCludesCancelled: hasCancelledEvent ? true : false });
    };

    const openSuggestionDialog = () => {
      setsuggestionDialogOpen(true);
    };

    const handlePlanning = (patientId: string) => {
      calendarStore.setContinuousView(false);

      navigateToCalendar(navigate, {
        patientId: Number(patientId),
      });
    };

    const handleContinuousPlanning = (patientId: string) => {
      calendarStore.setContinuousView(true);
      navigateToCalendar(navigate, {
        patientId: Number(patientId),
      });
    };

    const handleAppointmentSuggestionClose = (wasSaved: boolean) => {
      setsuggestionDialogOpen(false);
    };

    // useEffect(() => {
    //   const fetchData = async () => {
    //     try {
    //       console.log("Get Solutions in use Effect in Terimin");
    //       const response = await getSolutions(patientId, 4);
    //       setSuggestionData(response);

    //       // setPatients(response);
    //     } catch (error) {
    //       console.log("error", error);
    //     }
    //   };

    //   fetchData();
    // }, [isSuggestionDialogOpen]);

    // Get the current date and time
    const currentDate: any = new Date();
    // console.log("currentData", currentDate);

    // console.log("DataAA", suggestionData);

    const handleOpenWarningDialog = (appointmentId: any, appointmentStart: string | undefined) => {
      // Create an object with appointmentId and appointmentStart
      const appointmentInfo = { id: appointmentId, start: appointmentStart };
      setSelectedAppointment(appointmentInfo);
      setWarningDialogOpen(true);
    };

    const handleDelete = async () => {
      if (isDeleting) return; // ignore double-clicks while in flight
      try {
        if (deleteEvent?.isContinuous)
          await deleteContinuousAppointment({
            appointmentId: deleteEvent?.selectedAppointment as string,
            patientId: patientId,
          });
        else
          await deleteAppointment({
            appointmentId: deleteEvent?.selectedAppointment as string,
            patientId: patientId,
          });
      } catch (error) {
        // Error snackbar comes from the global MutationCache handler.
        console.error("Error deleting appointment:", error);
      } finally {
        // Close only after the delete AND the refetches finished, so the list
        // is already up to date the moment the dialog disappears.
        setDeleteEvent(null);
      }
    };

    const deleteAllUnscheduledAppointments = async () => {
      if (dataSaving) return; // ignore double-clicks while in flight
      try {
        setDataSaving(true);
        await deleteUnscheduledAppointments({ patientId });
      } catch (error) {
        // Error snackbar comes from the global MutationCache handler.
        console.error("Error deleting unscheduled appointments:", error);
      } finally {
        setDataSaving(false);
        setOpenDeleteDialog(false);
        setInCludesCancellation(false);
      }
    };

    // Function to show the Notes component
    const handleAddNotes = (appointmentId: string) => {
      setSelectedAppointmentId(appointmentId);
      setShowNotesDialog(true);
    };

    const handleCloseNotesDialog = () => {
      setShowNotesDialog(false);
    };

    return (
      <Grid container direction="column">
        <Divider textAlign="left">
          <div style={{ textAlign: "left", fontWeight: "bold" }}>Standardtermine</div>
        </Divider>
        {appointments.length > 0 && (
          <Grid
            item
            xs={"auto"}
            sx={{
              border: "0px red solid",
              marginTop: 2,
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between", // Ensures spacing between items
            }}
          >
            {/* Left-aligned buttons */}
            <Box sx={{ display: "flex", gap: 1 }}>
              <Button
                variant="contained"
                sx={{ marginRight: 1 }}
                onClick={openSuggestionDialog}
                startIcon={<AutoAwesome />}
              >
                KI
              </Button>
              {canSeeFeaturePreview && (
                <Tooltip title="Planungs-Agent">
                  <Button
                    variant="contained"
                    color="primary"
                    sx={{ marginRight: 1, minWidth: "auto", display: "flex" }}
                    onClick={() => {
                      startRescheduling();
                      handlePlanning(patientId);
                    }}
                  >
                    <AutoFixHigh />
                    Plan KI
                  </Button>
                </Tooltip>
              )}
              <Button
                variant="contained"
                color="primary"
                onClick={() => handlePlanning(patientId)}
                startIcon={<EditCalendar />}
              >
                Planen
              </Button>
            </Box>
            <Tooltip title={"Alles löschen"}>
              {/* Right-aligned delete icon */}
              <Delete
                sx={{
                  cursor: "pointer",
                  marginLeft: "auto",
                }}
                onClick={handleOpenDialog}
              />
            </Tooltip>
          </Grid>
        )}

        {openDeleteDialog && (
          <WarningDialog
            open={true} // Ensure the warning dialog is open
            onClose={handleCloseDialog} // Function to close the dialog
            onContinue={deleteAllUnscheduledAppointments} // Function to continue despite unsaved changes
            title="Löschen Sie ungeplante Termine"
            loading={dataSaving}
            content={
              dataSaving ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <CircularProgress size={24} />
                  Löschen läuft, bitte warten...
                </Box>
              ) : inCludesCancellation ? (
                "Einige Termine sind mit Stornierungen verbunden. Diese werden auf 'geklärt' gesetzt."
              ) : (
                "Sind Sie sicher, dass Sie alle ungeplanten Termine löschen möchten?"
              )
            }
            isConfirmSave
          />
        )}
        {/* {appointments && ( <Tooltip title="Open Appointment Suggestion">
        <Button
          sx={{
            width: 100,
            height: 40,
            padding: "3px",
            marginLeft: "4px",
            variant:"outlined" ,
            backgroundColor:"red"

          }}
          onClick={() => {
            openSuggestionDialog();
            // Additional actions you want to perform
          }}
        >
          Suggestion
        </Button>
      </Tooltip>)}  */}
        {/* <Grid item xs={12} sm={6} md={4} lg={3}> */}

        <TerminView
          appointments={appointments}
          patientId={patientId}
          appointmentsLoading={appointmentsLoading}
          isView={TerminViewConstants.UNSCHEDULED_TERMIN}
          setUnScheduledSelectedAppointmentId={setSelectedAppointmentId}
          setDeleteEvent={handleDeleteEvent}
        />

        <Divider textAlign="left">
          <div style={{ textAlign: "left", fontWeight: "bold" }}>Dauertermine</div>
        </Divider>
        {continuousAppointments && continuousAppointments.length > 0 && (
          <>
            <Grid
              item
              xs={"auto"}
              // alignSelf="flex-end"
              sx={{ border: "0px red solid", marginTop: 2 }}
            >
              {/* <Button
            variant="contained"
            sx={{ marginRight: 1 }}
            onClick={openSuggestionDialog}
            startIcon={<AutoAwesome />}
          >
            KI
          </Button> */}
              <Button
                variant="contained"
                color="primary"
                onClick={() => handleContinuousPlanning(patientId)}
                startIcon={<EditCalendar />}
              >
                Planen
              </Button>
            </Grid>
          </>
        )}

        <TerminView
          appointments={continuousAppointments as unknown as ContinuousAppointmentDto[]}
          patientId={patientId}
          appointmentsLoading={appointmentsLoading}
          isView={TerminViewConstants.UNSCHEDULED_CONT_TERMIN}
          setUnScheduledSelectedAppointmentId={setSelectedAppointmentId}
          setDeleteEvent={handleDeleteEvent}
        />
        {/* Render the WarningDialog conditionally */}
        {selectedAppointmentId && deleteEvent && (
          <WarningDialog
            open={deleteEvent.isDeleteDialogOpen}
            onClose={() => setDeleteEvent(null)}
            onContinue={handleDelete}
            title="Termin löschen"
            loading={isDeleting}
            content={
              isDeleting ? (
                <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                  <CircularProgress size={24} />
                  Löschen läuft, bitte warten...
                </Box>
              ) : deleteEvent.inCludesCancelled ? (
                "Dieser Termin ist mit einer Stornierung verbunden. Die Stornierung wird auf 'geklärt' gesetzt."
              ) : (
                "Möchten Sie diesen Termin wirklich löschen?"
              )
            }
          />
        )}
        {showNotesDialog && selectedAppointmentId && (
          <AppointmentNotes
            appointmentId={selectedAppointmentId}
            showDialog={showNotesDialog}
            onClose={handleCloseNotesDialog}
          />
        )}
        <AppointmentSuggestion
          open={isSuggestionDialogOpen}
          onClose={handleAppointmentSuggestionClose}
          patientId={patientId}
          blockedData={blockedData}
          setblockedData={setblockedData}
          patientAvailabilityData={patientAvailabilityData}
          setPatientAvailabilityData={setPatientAvailability}
        />

        {/* </Grid> */}
      </Grid>
    );
  },
);

export default UnscheduledAppointments;
